import Vue from 'vue';


const siteAddress ={
   state :{
      siteAddress:[],
   },
   getters:{
     siteAddress(state){
       return state.siteAddress;
     }
   },
   mutations:{
     getSiteAddress(state,payload)
     {
     state.siteAddress = payload;
     },     
   },
   actions: {
    getSiteAddress(context, payload) {
      const url = 'Register/SiteAddress';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getSiteAddress', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    }, 
    updateSiteAddress(context, payload){
      const url = `SiteAddress/${ payload.ID }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getSiteAddress')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createSiteAddress(context, payload){
      const url = `SiteAddress`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getSiteAddress')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteSiteAddress(context, payload){
      const url = `SiteAddress/${ payload.ID }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getSiteAddress')
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default siteAddress